import { getCookie } from './cookies'
import { ARVORE_ROOT_PATH } from 'config/vars'

const fetch = global.fetch

const ANALYTICS_PATH = '/analytics/v1/event'

const isRunningOnLocalBundleInsideNativeApp = () =>
  typeof window !== 'undefined' &&
  !!window.ReactNativeWebView &&
  window.location.hostname === 'localhost'

const resolveAnalyticsEndpoint = () =>
  isRunningOnLocalBundleInsideNativeApp()
    ? `${ARVORE_ROOT_PATH}${ANALYTICS_PATH}`
    : ANALYTICS_PATH

export const post_event = (event, value) => {
  const token = getCookie('access_token')

  const settings = {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({ event: event, value: value })
  }

  return fetch(resolveAnalyticsEndpoint(), settings)
}
